app.controller("NewsletterFormController",
	["$scope", "$http", "$window", function($scope, $http, $window) {
		$scope.submitted = false;
		$scope.sendingForm = false;

		$scope.data = {};

		$scope.data.submitUrl = document.querySelector("link[rel='canonical']").href;

		var errors = {
			name: 'Syötä nimi',
			email: 'Virheellinen sähköpostiosoite'
		};
		$scope.errors = {};


		$scope.submitForm = function() {
			for (var i in $scope.newsletter_form) {
				if (!$scope.newsletter_form.hasOwnProperty(i) || i.match(/^\$/)) {
					continue;
				}
				$scope.data[i] = $scope.newsletter_form[i].$modelValue;
			}
			$scope.data.formID = 'newsletterForm';

			$scope.sendingForm = true;
			if ($window.wakeTestEmail) {
				$scope.data.wakeTestEmail = $window.wakeTestEmail;
			}

			$http({
				method: "POST",
				url: "/api/1/form/submit",
				data: $scope.data
			})
			.then(function(data) {
				$scope.errors = {};
				$scope.submitted = true;
				$scope.sendingForm = false;

				/* Tilattu uutiskirje */
				// adf.ClickTrack(this, 342679, 'Uutiskirjeen Tilaus',{});
				_gaq.push(['_trackEvent', 'Uutiskirje', 'Lähetä']);
			},
			function(results) {
				$scope.sendingForm = false;
				
				for(var key in results.data.data) {
					if(!results.data.data[key].success) {
						$scope.errors[key] = errors[key];
					} else {
						$scope.errors[key] = null;
					}
				}
			});
		};
	}]
);
